/**
 * Validates an IANA time zone name using the runtime Intl API.
 * Uses a fixed locale so behaviour is consistent across call sites.
 */
export function isValidIanaTimeZone(value) {
    try {
        new Intl.DateTimeFormat("en-US", { timeZone: value });
        return true;
    }
    catch {
        return false;
    }
}
/**
 * Effective "organisation working" timezone: valid org setting wins, then valid owner profile, else UTC.
 */
export function pickEffectiveOrganisationTimezone(params) {
    if (params.orgTimezone && isValidIanaTimeZone(params.orgTimezone)) {
        return params.orgTimezone;
    }
    if (params.ownerTimezone && isValidIanaTimeZone(params.ownerTimezone)) {
        return params.ownerTimezone;
    }
    return "UTC";
}
